import React from 'react';
import { AppointmentStatus } from '@bb/domain/dist/types';
import {
  MenuItem,
  Menu,
  Checkbox,
  Icon,
  Text,
  Button,
  Divider,
} from 'components';
import { CheckboxProps } from 'components/Checkbox';
import styled from 'styled-components';
import { useShowingsCalendarContext } from '../ShowingsCalendarContext';
import {
  AgentCalendarMenu,
  StatusMenuItem,
  ShowingsCalendarAppointmentStatus,
} from '../types';
import { getStatusMenuItems } from '../constants';

type StatusMenuMobileProps = {
  setStatusOpen: React.Dispatch<React.SetStateAction<boolean>>;
  localStatuses: ShowingsCalendarAppointmentStatus[] | undefined;
  setLocalStatuses: React.Dispatch<
    React.SetStateAction<ShowingsCalendarAppointmentStatus[] | undefined>
  >;
  statusOnChange: (
    key: ShowingsCalendarAppointmentStatus,
  ) => CheckboxProps['onChange'];
};

const StatusMenuMobile: React.FC<StatusMenuMobileProps> = ({
  statusOnChange,
  localStatuses,
  setLocalStatuses,
  setStatusOpen,
}) => {
  const context = useShowingsCalendarContext();
  const { clearStatuses, selectedMenuOption, setStatuses, setPendingStatus } =
    context;

  const clearHandler = React.useCallback(() => {
    setLocalStatuses([]);
    setStatusOpen(false);
    clearStatuses();
  }, [clearStatuses, setLocalStatuses, setStatusOpen]);

  const saveHandler = () => {
    const isAppointmentStatus = (
      status: ShowingsCalendarAppointmentStatus,
    ): status is AppointmentStatus => status !== 'pending';

    const filteredLocalStatuses = localStatuses?.filter(isAppointmentStatus);
    if (localStatuses.includes('pending')) setPendingStatus(true);
    setStatuses(filteredLocalStatuses);
    setStatusOpen(false);
  };

  return (
    <StyledMenu>
      <StyledMenuHeader>
        <StyledIconContainer
          className="icon-container"
          onClick={() => setStatusOpen(false)}
        >
          <Icon type="antdLeftOutlined" className="left-icon" />
        </StyledIconContainer>
        <Text>Filter by Status</Text>
        <Divider />
      </StyledMenuHeader>
      {getStatusMenuItems({
        isBuyer: selectedMenuOption === AgentCalendarMenu.Buyer,
      }).map(({ label, key }: StatusMenuItem) => (
        <MenuItem key={key}>
          <Checkbox
            onChange={statusOnChange(key)}
            checked={localStatuses?.includes(key)}
            id={`${key}-checkbox`}
          >
            {label}
          </Checkbox>
        </MenuItem>
      ))}

      <StyledMenuFooter>
        <Divider />
        <div className="button-container">
          <Button type="text" onClick={clearHandler} id="status-clear-button">
            Clear
          </Button>
          <Button type="primary" onClick={saveHandler} id="status-save-button">
            Save
          </Button>
        </div>
      </StyledMenuFooter>
    </StyledMenu>
  );
};

const StyledMenu = styled(Menu)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding: 0 !important;
  li {
    padding: 10px !important;
  }
  z-index: 101;
`;

const StyledMenuHeader = styled.div`
  text-align: center;
  .icon-container {
    justify-content: center;
    margin-left: 5px;
    padding: 0;
  }
  .div {
  }
  min-height: 40px;
`;

const StyledIconContainer = styled.div`
  text-align: left;
  transform: translateY(50%);
`;

const StyledMenuFooter = styled.div`
  text-align: right;
  .button-container {
    padding: 10px;
  }
`;

export default StatusMenuMobile;
